import React from 'react';
import Loader from '../../Loader/Loader';
import * as S from './Button.styles';
import { StyledButtonProps } from './Button.styles';

interface ButtonProps extends StyledButtonProps, React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
}

const Button: React.FC<ButtonProps> = ({ loading, children, disabled, ...rest }) => {
  return (
    <S.StyledButton {...rest} disabled={loading || disabled}>
      {loading ? (
        <S.LoadingWrap>
          <S.GhostLabel aria-hidden>{children}</S.GhostLabel>
          <S.SpinnerOverlay>
            <Loader size="small" />
          </S.SpinnerOverlay>
        </S.LoadingWrap>
      ) : (
        children
      )}
    </S.StyledButton>
  );
};

export default Button;
